<template>
  <section>
    <slot></slot>
  </section>
</template>
